import { FontType } from '@modusign/react-signing/types';

/**
 * All font size based on point (pt)
 */
export const FONT_SIZE_DEFAULT = 12;
export const FONT_SIZE_MIN = 4;
export const FONT_SIZE_MAX = 60;
export const FONT_SIZES = Object.freeze([
  4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 24, 30, 36, 48, 60,
]);
export const DESCENDER_RATIO_PER_FONT_SIZE = 0.27;

export const FONT_TYPES_MAP: Record<FontType, string> = {
  NOTO_SANS: '본고딕',
  NOTO_SERIF: '본명조',
};

export const SELECTABLE_FONT_TYPE: FontType[] = ['NOTO_SANS', 'NOTO_SERIF'];
